<div id="consulta-grid" class="container-fluid">
  <h3>Carregar Arquivo do Cliente no Servidor</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="Form">
          <div class="d-flex flex-wrap form-items">
            <mat-form-field class="min-width">
              <mat-label>Cliente:</mat-label>
              <mat-select formControlName="clienteSelecionado">
                <mat-option value="">Todos</mat-option>
                <mat-option *ngFor="let d of listaClientes" [value]="d.clienteId">
                  {{ d.nome }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Período Inicial:</mat-label>
              <input matInput autocomplete="off" maskDate [matDatepicker]="periodoInicial" formControlName="periodoInicial" />
              <mat-datepicker-toggle matSuffix [for]="periodoInicial"></mat-datepicker-toggle>
              <mat-datepicker #periodoInicial></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Período Final:</mat-label>
              <input matInput autocomplete="off" maskDate [matDatepicker]="periodoFinal" formControlName="periodoFinal" />
              <mat-datepicker-toggle matSuffix [for]="periodoFinal"></mat-datepicker-toggle>
              <mat-datepicker #periodoFinal></mat-datepicker>
            </mat-form-field>

            <div class="button-container">
              <button type="button" mat-icon-button matTooltip="Limpar Campos" (click)="clearFields()">
                <i class="fas fa-eraser eraser-button"></i>
              </button>
              <button type="button" mat-icon-button class="pesquisar" (click)="paging.index = 0; listarGrid()" [disabled]="Form.invalid">
                <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
              </button>
              <button class="float-right" mat-flat-button color="primary" (click)="openNovo()" [ngStyle]="{ margin: '-4px' }">
                Novo <i class="fas fa-plus" style="font-size: 12px"></i>
              </button>
            </div>
          </div>
        </form>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content class="no-padding" [hidden]="!exibirGrid">
      <div [hidden]="isLoading || loadArquivo?.length === 0">
        <div>
          <table class="scroll-table" mat-table [dataSource]="grid">
            <ng-container matColumnDef="operacao">
              <th mat-header-cell *matHeaderCellDef>Operação</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.operacao }}</td>
            </ng-container>

            <ng-container matColumnDef="ipServidor">
              <th mat-header-cell *matHeaderCellDef>IP Servidor</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.ipServidor }}</td>
            </ng-container>

            <ng-container matColumnDef="pasta">
              <th mat-header-cell *matHeaderCellDef>Pasta</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.pasta }}</td>
            </ng-container>

            <ng-container matColumnDef="critica">
              <th mat-header-cell *matHeaderCellDef>Crítica</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.critica }}</td>
            </ng-container>

            <ng-container matColumnDef="tipo_Arquivo">
              <th mat-header-cell *matHeaderCellDef>Tipo de Arquivo</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.tipo_Arquivo }}</td>
            </ng-container>

            <ng-container matColumnDef="nome_Tabela">
              <th mat-header-cell *matHeaderCellDef>Nome da Tabela</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.nome_Tabela }}</td>
            </ng-container>

            <ng-container matColumnDef="dtLoadDados">
              <th mat-header-cell *matHeaderCellDef>Data de Load</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.dtLoadDados | date : "short" }}</td>
            </ng-container>

            <ng-container matColumnDef="usuLoadDados">
              <th mat-header-cell *matHeaderCellDef>Usuário de Load</th>
              <td mat-cell *matCellDef="let grid">{{ grid?.usuLoadDados }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>

      <app-paginacao [hidden]="isLoading" [pageIndex]="paging?.index" [pageSize]="paging?.size" [length]="paging?.length" (page)="onPageChange($event)" [pageSizeOptions]="[10, 20, 50]">
      </app-paginacao>

      <div class="d-flex flex-column justify-content-end align-items-end pr-2 py-2">
        <div *ngIf="!isLoading && grid?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px">
          Nenhum registro para o período!
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
